import { Redirect } from "@outschool/ui-utils";
import React from "react";

import { useFeatureFlag } from "../../../lib/FeatureFlags";

const RedirectWrapper = ({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) => {
  const newParentDashboardEnabled = useFeatureFlag("new-parent-dashboard-v1");

  if (newParentDashboardEnabled && to) {
    return <Redirect to={to} />;
  }

  return <>{children}</>;
};

export default RedirectWrapper;
